var map = {
	"./default.json": "369a",
	"./es-ES.json": "4109",
	"./fr-FR.json": "cfe42",
	"./it-IT.json": "bf7d",
	"./pt-PT.json": "7b75",
	"./ru-RU.json": "b69a",
	"./tr-TR.json": "3ba8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "741a";